import { yup } from '@framework/validation';
import { BooleanWidgetComponent } from './BooleanWidgetComponent';
import {
  BooleanConfigComponent,
  BooleanWidgetConfigSchema,
} from './BooleanWidgetConfigComponent';

//TODO importazione React
import { CheckSquareOutlined } from '@ant-design/icons';
import React from 'react';
import type { IWidgetType } from '~packages/engine/src/schema/widgets/IWidgetType';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference';
import { CustomWarningsRule } from '../../../../rules/repository/custom-warnings/CustomWarnings.rule';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { createCommonFormSchema } from '../common/createCommonFormSchema';
import type { IBooleanWidget } from './IBooleanWidget';

export const BooleanWidgetType: IWidgetType<IBooleanWidget> = {
  name: 'Checkbox',
  icon: <CheckSquareOutlined />,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Input,
  type: WidgetType.Boolean,
  hasValue: true,
  getReference: getSimpleWidgetReference(Datatype.Boolean),
  formComponent: BooleanWidgetComponent,
  createFormSchema: ({ widget }) =>
    createCommonFormSchema(yup.boolean(), widget),
  previewComponent: BooleanWidgetComponent,
  configValidator: BooleanWidgetConfigSchema,
  configComponent: BooleanConfigComponent,
  translationSchema: tran.widget({
    label: tran.rte(),
    helpText: tran.rte(),
    text: tran.rte(),
    rules: tran.rules(),
  }),
  rules: [CustomWarningsRule],
};
